<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{labelConstants.Logout}}</h4>
    <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
  </div>
  <mat-dialog-content class>
    <p class="confirmation">{{labelConstants.AreYouSure}} {{ action }}? </p>
    <img *ngIf="ImageSrc" [src]="ImageSrc" alt class="profile-pic-delete" />
  </mat-dialog-content>
  <div mat-dialog-actions class="dialog-actions dialogue-footer text-center mb-3">
    <button class="btn btn-secondary" [mat-dialog-close]="true">{{labelConstants.Logout}}</button>
    <button class="btn btn-primary" [mat-dialog-close]="false">{{labelConstants.Cancel}}</button>
  </div>
</div>